import { render, staticRenderFns } from "./form.vue?vue&type=template&id=a099ed32"
import script from "./form.vue?vue&type=script&lang=js"
export * from "./form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a099ed32')) {
      api.createRecord('a099ed32', component.options)
    } else {
      api.reload('a099ed32', component.options)
    }
    module.hot.accept("./form.vue?vue&type=template&id=a099ed32", function () {
      api.rerender('a099ed32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/send-list/form.vue"
export default component.exports